import { Component } from '@angular/core';
import { AngularMaterialModule } from "../../../../angular-material.module";
import { Theme, ThemeService } from "../../../services/theme.service";
import { NgIf, NgSwitch, NgSwitchCase } from "@angular/common";

@Component({
	selector: 'app-theme-selector',
	standalone: true,
	imports: [
		AngularMaterialModule,
		NgIf,
		NgSwitch,
		NgSwitchCase
	],
	templateUrl: './theme-selector.component.html',
	styleUrls: ['./theme-selector.component.scss']
})
export class ThemeSelectorComponent {
	public activeTheme: any = Theme.LIGHT;
	public readonly theme = Theme;

	constructor(private themeService: ThemeService) {
		this.activeTheme = themeService.getTheme();
	}

	toggleTheme() {
		this.themeService.toggleTheme();
		this.activeTheme = this.themeService.getTheme()

		// store to localstorage
		localStorage.setItem('theme', this.activeTheme);
	}
}
